import i18n, { TFunction } from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import intervalPlural from 'i18next-intervalplural-postprocessor'

import { BrowserStorage, Instance, Languages, lookupLocalStorage, NS } from '@const/consts'
import * as Sentry from '@sentry/browser'
import { SeverityLevel } from '@sentry/types'

const instance = window.location.hostname.match(/global|ru|com.br|africa|vn/g)?.[0] ?? window.localStorage.getItem(BrowserStorage.INSTANCE) ?? Instance.GLOBAL
window.localStorage.setItem(BrowserStorage.INSTANCE, instance)

const isRussia = instance === Instance.RUSSIAN
const allLangs = [Languages.EN, Languages.RU, Languages.PT, Languages.VI];
const langsWithoutRussian = allLangs.filter(val => val !== Languages.RU);
const lngFromLS = window.localStorage.getItem(lookupLocalStorage) ?? Languages.EN;

let translates: string[] = langsWithoutRussian

if (isRussia) {
  translates = allLangs
}

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    lng: lngFromLS,
    fallbackLng: translates,
    preload: translates,
    ns: NS,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    debug: false,

    react: {
      nsMode: 'default'
    },

    interpolation: {
      escapeValue: false
    }
  })
  .catch((err: TFunction) => {
    const errorText = 'i18n error'
    const errorLevel: SeverityLevel = 'fatal'
    const errorInfo = { err }

    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setLevel(errorLevel)
      scope.setExtras(errorInfo)
      Sentry.captureException(new Error(errorText))
    })
  })

export default i18n
